import React from 'react';
import { motion } from 'framer-motion';
import { FileDown, FileSpreadsheet, FileType, X } from 'lucide-react';
import { AudienceLevel, Cohort } from '../../types/pathway';
import { PathwayDocument } from './PathwayDocument';
import { PathwayButton } from './PathwayButton';
import { printPathwayDocument } from './PrintSurface';
interface DocumentViewerProps {
  open: boolean;
  pathwayName: string;
  company: string;
  cohort: Cohort | null;
  audience: AudienceLevel | 'any';
  items: string[];
  fields: string[];
  onClose: () => void;
  onDownloadWord: () => void;
  onDownloadCsv: () => void;
}
export function DocumentViewer({
  open,
  pathwayName,
  company,
  cohort,
  audience,
  items,
  fields,
  onClose,
  onDownloadWord,
  onDownloadCsv
}: DocumentViewerProps) {
  if (!open) return null;
  return <div className="fixed inset-0 z-[60] flex flex-col bg-gray-900/80" role="dialog" aria-modal="true" aria-labelledby="document-viewer-title" data-id="element-1534" data-mp="98ugwflsjjlg">
      <div className="flex flex-shrink-0 items-center justify-between gap-4 border-b border-gray-200 bg-white px-6 py-4" data-id="element-1535" data-mp="2a52q0hk4i6lo">
        <div className="min-w-0" data-id="element-1536" data-mp="2f45vu47xggup">
          <h2 id="document-viewer-title" className="truncate text-lg font-bold text-gray-900" data-id="element-1537" data-mp="2f5798fcf1ffl">
            {pathwayName || 'Recommended Learning Pathway'}
          </h2>
          <p className="text-sm text-gray-600" data-id="element-1538" data-mp="255zvvs5olksh">
            Document preview · what the prospect receives
          </p>
        </div>
        <div className="flex flex-shrink-0 items-center gap-3" data-id="element-1539" data-mp="2xu44alfn0byv">
          <PathwayButton variant="secondary" size="sm" onClick={onDownloadWord} className="min-w-0 px-4" data-id="element-1540" data-mp="2xtlwqsniybbn">
            <FileType size={16} data-id="element-1541" data-mp="2o3ixiapt814v" />
            Word
          </PathwayButton>
          <PathwayButton variant="secondary" size="sm" onClick={onDownloadCsv} className="min-w-0 px-4" data-id="element-1542" data-mp="3btmzkdncnstr">
            <FileSpreadsheet size={16} data-id="element-1543" data-mp="3gmznelk7fvlg" />
            CSV
          </PathwayButton>
          <PathwayButton size="sm" onClick={() => printPathwayDocument(pathwayName)} data-id="element-1544" data-mp="3qg2hngamh762">
            <FileDown size={16} data-id="element-1545" data-mp="3mdflj36x5032" />
            Save as PDF
          </PathwayButton>
          <button type="button" onClick={onClose} aria-label="Close preview" className="rounded-lg p-2 text-gray-500 transition-colors hover:bg-gray-50 hover:text-gray-900" data-id="element-1546" data-mp="3hech9kyrixw5">
            <X size={18} data-id="element-1547" data-mp="32rja52zecyf1" />
          </button>
        </div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="flex-1 overflow-auto p-8" data-id="element-1548" data-mp="32p6h9us3p3n7">
        <div className="mx-auto w-max" data-id="element-1549" data-mp="2ori8hlbb5myi">
          <PathwayDocument pathwayName={pathwayName} company={company} cohort={cohort} audience={audience} items={items} fields={fields} data-id="element-1550" data-mp="2oqgjecxgizxs" />
        </div>
      </motion.div>
    </div>;
}